<template>

  <div class="main-dask">
    <p v-if="!params" class="rows-name middle-high">Извините, датчика нет</p>

    <div v-if="params" class="widget-area">
      <SensorWidget 
        :name='params?.name' 
        :mac="mac"
        :temperature="params?.temperature"
        :vibration="params?.vibrations"
        :total_time="params?.total_time"
        :month_time="params?.month_time"
        :week_time="params?.week_timek"
        :day_time="params?.day_time"
        :rpm="params?.rpm"
        :power="params?.power"
        :id="params?.id_sensor"
        :message="message"
        :addition_params="params?.addition_params"
        :isMotorLifeGone="checkMotorLife(params?.motor_life_offset, params?.motor_life_start, params?.total_time)"
        :sensor="true"
        :date_update_param="params?.date_update_param"
        :isSensorImage="params?.sensor_image"
        :isPlaceImage="params?.place_image"
        @open-graf="openGraphWindow"
        :levelVibrationsCode="params?.level_vibrations_code"
        @open-param="openParamWindow" 
      />
    </div>

    <Transition name="fade" mode="out-in">
      <WindowParam 
        v-if="switcherParam"
        :id="paramWindow.id"
        :mac="mac"
        :power="paramWindow.power"
        :rpm="paramWindow.rpm"
        :motor_life_offset="paramWindow.motor_life_offset"
        :motor_life_start="paramWindow.motor_life_start"
        :name_element="paramWindow.name"
        :date="paramWindow.date"
        :addition="false"
        typeWindow="sensor"
        :company_id="paramWindow.company"
        :addition_params="paramWindow.addition_params"
        :isNewGroup="paramWindow.isNewGroup"
        :showSensorImage="paramWindow.sensor_image"
        :showPlaceImage="paramWindow.place_image"
        :total_time="paramWindow.total_time"
        :groupSensor="paramWindow.groupSensor"
        @closeWindow="closeParamWindow"
        @newData="catchChanging"
        @child-event="handleChildMessage"

      />
    </Transition>

    <Transition name="fade" mode="out-in">
      <WindowGraph
        v-if="switcherGraph"
        @closeWindow="closeGraphWindow"
        :name="graphWindow.name"
        :id="graphWindow.id"
        :listElements="graphWindow.listElements"
        :typeWindow="'sensor'"
      />
    </Transition>
  </div>


</template>

<script>



import SensorWidget from '@/pages/dashboard/SensorWidget.vue'

import WindowParam from '@/pages/dashboard/WindowParam.vue'
import WindowGraph from '@/pages/dashboard/WindowGraph.vue'


export default {
  data() {
    return {
      warn: {},
      graphWindow: {},
      switcherGraph: false,
      params: null,
      switcherParam: false,
      isVisible: true,
      message: '',
      group: null,
      isNewGroup: null,
      addition_params: ['rpm', 'power'],
      paramWindow: {
      },
      message: null,
      timeoutID: null
    }
  },
  props: ['mac', 'agreement'],

  components: {
    SensorWidget,
    WindowParam,
    WindowGraph
  },
  methods: {
    
    checkMotorLife(motor_life_offset, motor_life_start, total_time) {
      if (!motor_life_offset || !motor_life_start || !total_time) {
        return false
      } else {
        return (motor_life_offset+motor_life_start) < total_time
      }
    },
    catchChanging(params) {
      this.params = params
    },
    handleChildMessage(msg) {
      this.message = msg
    },

    async getSensor() {

      try {
        const token = localStorage.getItem('token')

        if (!token && !this.agreement) {
          throw new Error("");

        }
        const response = await this.axios.get(`/sensor/get_sensor?mac=${this.mac}`)

        this.params = response.data.data

      } catch (error) {

        this.$router.push('/');
        this.isVisible = !this.isVisible
      }
    },

    openParamWindow(id, name, typeWindow) {
      const groups = { 0: 'Без группы', 1: 'Группа 1', 2: 'Группа 2', 3: 'Группа 3' }

      this.paramWindow.typeWindow = typeWindow
      this.paramWindow.id = this.params.id_sensor
      this.paramWindow.mac = this.params.MAC
      this.paramWindow.power = this.params.power
      this.paramWindow.rpm = this.params.rpm
      this.paramWindow.motor_life_offset = this.params.motor_life_offset
      this.paramWindow.motor_life_start = this.params.motor_life_start
      this.paramWindow.name = this.params.name
      this.paramWindow.date = this.params.created_date
      this.paramWindow.company = this.params.company_id ? this.params.company_id : 0
      this.paramWindow.addition_params = this.params.addition_params
      this.paramWindow.groupSensor = groups[this.params.group]
      this.paramWindow.isNewGroup = this.params.is_new
      this.paramWindow.place_image = this.params.place_image
      this.paramWindow.sensor_image = this.params.sensor_image
      this.paramWindow.total_time = this.params.total_time
      this.switcherParam = true
    },

    closeParamWindow() {
      this.switcherParam = false
    },

    async updateData() {
      await this.getSensor()
      if (!this.flagStopTimeout) {
        this.timeoutID = setTimeout(this.updateData, 10000)
      }
    },

    openGraphWindow() {
      this.switcherGraph = true
      const listElements = this.params
      this.graphWindow = {
        id: this.params?.id,
        name: this.params?.name,
        typeWindow: 'sensor',
        listElements: [listElements]
      }
    },

    closeGraphWindow() {
      this.switcherGraph = false
    },

  },
  async created() {
    await this.getSensor()
    this.flagStopTimeout = false
    if (this.params) {
      this.timeoutID = setTimeout(await this.updateData, 10000)
    }
  },

  beforeUnmount() {
    this.flagStopTimeout = true
    clearTimeout(this.timeoutID)
  }
}
</script>

<style scoped lang="scss">
.solo-company {
  overflow: hidden;
  transition: all .2s ease;
  padding: 24px 30px;
}

.widget-row-place {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.rows-name {
  padding: 10px 20px;
  color: var(--gray-dark-color);
}

.widget-area {
  background: rgba(0, 0, 0, 0.02);
  border-radius: 3px;
  margin: 5px 0;
}

.param-place {
  display: flex;
  justify-content: space-between;
  padding: 0 19px;
  max-width: 560px;
}

.main-dask {
  height: 93vh;
  padding: 10px 1vw;
  overflow-y: auto;
}

@media screen and (max-width: 1210px) {
  .widget-row-place {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 810px) {
  .widget-row-place {
    grid-template-columns: repeat(1, 1fr);
  }
}

.first-line {
  display: flex;
  justify-content: space-between;
  padding: 3px 5px;
  max-width: 543px;
}
</style>
